import script from "./UserQARecord.vue?vue&type=script&setup=true&lang=js"
export * from "./UserQARecord.vue?vue&type=script&setup=true&lang=js"

import "./UserQARecord.vue?vue&type=style&index=0&id=17beab4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17beab4a"]])

export default __exports__